import { useEffect, useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import DashboardLayout from "@/components/DashboardLayout";
import { OpportunityForm, ApplicantsTable } from "@/components/PortalShared";
import { PortalStats, OpportunitiesPanel } from "@/pages/FacultyPortal";
import { api } from "@/lib/api";

export default function OrgPortal() {
    const [stats, setStats] = useState(null);
    const [opps, setOpps] = useState({ projects: [], internships: [] });
    const [applicants, setApplicants] = useState([]);

    const load = () => {
        api.get("/org-portal/overview").then((r) => setStats(r.data)).catch(() => {});
        api.get("/org-portal/opportunities").then((r) => setOpps(r.data)).catch(() => {});
        api.get("/org-portal/applicants").then((r) => setApplicants(r.data)).catch(() => {});
    };
    useEffect(() => { load(); }, []);

    return (
        <DashboardLayout title="Organization Portal">
            <div className="space-y-8" data-testid="org-portal">
                <PortalStats stats={stats} />
                <Tabs defaultValue="opportunities">
                    <TabsList data-testid="org-portal-tabs">
                        <TabsTrigger value="opportunities" data-testid="tab-opportunities">My Postings</TabsTrigger>
                        <TabsTrigger value="applicants" data-testid="tab-applicants">Applicants ({applicants.length})</TabsTrigger>
                    </TabsList>
                    <TabsContent value="opportunities" className="mt-6 space-y-6">
                        <div className="flex gap-3">
                            <OpportunityForm kind="project" portalPrefix="org-portal" onCreated={load} />
                            <OpportunityForm kind="internship" portalPrefix="org-portal" onCreated={load} />
                        </div>
                        <OpportunitiesPanel data={opps} reload={load} />
                    </TabsContent>
                    <TabsContent value="applicants" className="mt-6">
                        <ApplicantsTable applicants={applicants} onStatusChange={load} />
                    </TabsContent>
                </Tabs>
            </div>
        </DashboardLayout>
    );
}
